import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import BrandLogo from "../BrandLogo";

const Footer = () => (
  <footer className="border-t border-slate-200 bg-white text-slate-600">
    <div className="marketing-container py-10 sm:py-12">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-10">
        <div className="md:col-span-5">
          <div className="mb-4">
            <BrandLogo size="md" sub={false} />
          </div>
          <p className="max-w-md text-sm leading-relaxed text-slate-600">
            A Unit of Dmaskut Private Limited. UGC & NEP-2020 aligned 120-hour internship programs with verifiable digital certificates.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="mb-4 text-sm font-semibold text-slate-900">Platform</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-blue-600">Home</Link></li>
            <li><Link to="/programs" className="hover:text-blue-600">Programs</Link></li>
            <li><Link to="/about" className="hover:text-blue-600">About</Link></li>
            <li><Link to="/verify" className="hover:text-blue-600">Verify Certificate</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="mb-4 text-sm font-semibold text-slate-900">Account</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/register" className="hover:text-blue-600">Register</Link></li>
            <li><Link to="/login" className="hover:text-blue-600">Student Login</Link></li>
            <li><Link to="/admin/login" className="hover:text-blue-600">Admin Login</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="mb-4 text-sm font-semibold text-slate-900">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy-policy" className="hover:text-blue-600">Privacy Policy</Link></li>
            <li><Link to="/terms-of-service" className="hover:text-blue-600">Terms of Service</Link></li>
            <li><Link to="/contact" className="hover:text-blue-600">Contact</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-9 border-t border-slate-200 pt-6">
        <div className="grid gap-3 text-sm md:grid-cols-3">
          <div className="flex items-start gap-2"><Mail className="mt-0.5 h-4 w-4 flex-shrink-0 text-blue-600" /> <span className="break-all">support@kampuscompanion.com</span></div>
          <div className="flex items-start gap-2"><Phone className="mt-0.5 h-4 w-4 flex-shrink-0 text-blue-600" /> +91 9217242305</div>
          <div className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-blue-600" /> <span>Company Sarai, Rauza Road, Sasaram, Bihar - 821115</span></div>
        </div>
        <p className="mt-5 text-xs text-slate-500">Copyright {new Date().getFullYear()} Kampus Campanion. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;

